export default __webpack_public_path__ + "static/media/Square170.180adc8e.svg";